import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'
import Skeleton from '@ynap/skeleton'

const bem = new BEMHelper('OrderItemSkeleton')

const propTypes = {
    className: PropTypes.string
}

function OrderItemSkeleton({ className }) {
    return (
        <li className={bem(null, null, className)}>
            <Skeleton count={2} align="left" containerClassName={bem('skeletonInfo')} />
            <Skeleton className={bem('skeletonText1')} />
            <Skeleton className={bem('skeletonImage')} containerClassName={bem('imageContainer')} />
            <Skeleton className={bem('skeletonText2')} containerClassName={bem('container')} />
            <Skeleton className={bem('skeletonStatus')} containerClassName={bem('container')} />
        </li>
    )
}

OrderItemSkeleton.propTypes = propTypes

export default OrderItemSkeleton
